import { createContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@chakra-ui/react';

import { locales } from '../utils/constants/common';
import { logoutRequest } from '../services/auth';

export const AppContext = createContext({});

export default function AppContextWrapper({ children }) {
  const toast = useToast();
  const [user, setUserInfo] = useState(JSON.parse(localStorage.getItem('user')) || null);
  const [locale, setLocale] = useState(locales.es);
  const navigate = useNavigate();
  const isLoggedIn = !!user;

  const updateUserInfo = userInfo => {
    const user = {
      ...userInfo.user,
    };
    localStorage.setItem('user', JSON.stringify(user));
    setUserInfo(user);
  };

  const logout = async path => {
    try {
      await logoutRequest();
      localStorage.clear();
      setUserInfo(null);
      navigate('/', { state: { prevPath: path } });
    } catch (error) {
      console.error(error);
    }
  };

  const checkIfTokenExpires = (error, path) => {
    if (!error) return;
    if (error.name === 'JsonWebTokenError') {
      logout(path);
      toast({
        title: 'Tu sesión ha expirado',
        description: 'Debes iniciar sesión de nuevo para continuar',
        status: 'info',
        position: 'top-right',
        duration: 7000,
        isClosable: true,
      });
      return;
    }
    return;
  };
  return (
    <AppContext.Provider
      value={{
        user,
        logout,
        checkIfTokenExpires,
        locale,
        isLoggedIn,
        updateUserInfo,
      }}
    >
      {children}
    </AppContext.Provider>
  );
}
